import LeaveHistoryDetail from './leave-history-detail'
import ModalMessage from './modal-message'

export {
  LeaveHistoryDetail,
  ModalMessage,
}



// WEBPACK FOOTER //
// ./src/components/report/modal/index.js